module.exports = __webpack_public_path__ + "static/media/payment-icon-applepay.c28c7ed4.svg";